import { render, staticRenderFns } from "./ModalImportarUsuarios.vue?vue&type=template&id=e966b95c&"
import script from "./ModalImportarUsuarios.vue?vue&type=script&lang=js&"
export * from "./ModalImportarUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports